/* Move metafield sizing block into the Station Tabs SIZING panel. */
(function () {
  'use strict';

  function sizingPanel() {
    return (
      document.querySelector('[id^="st-sizing"].station-tabs-content') ||
      document.querySelector('[id^="st-sizing"]') ||
      document.querySelector('.station-tabs-content[id*="sizing"]')
    );
  }

  function inner(panel) {
    return panel.querySelector('.station-tabs-content-inner') || panel;
  }

  function isSizeGuideChrome(el) {
    if (!el || !el.querySelector) return false;
    return !!(
      el.querySelector('[data-action="open-size-guide-drawer"]') ||
      el.querySelector('.ProductSizingInfo__Guide') ||
      el.querySelector('.scr-open-size-chart') ||
      el.querySelector('.best-fit-size-chart')
    );
  }

  function place() {
    var block = document.querySelector('[data-product-sizing-info]');
    if (!block) return false;

    var panel = sizingPanel();
    if (!panel) return false;

    var host = inner(panel);

    Array.prototype.forEach.call(host.children, function (child) {
      if (child === block) return;
      if (child.hasAttribute && child.hasAttribute('data-product-sizing-info')) return;
      if (isSizeGuideChrome(child)) return;
      child.setAttribute('data-sizing-legacy-hidden', 'true');
      child.setAttribute('hidden', 'hidden');
    });

    if (block.parentNode !== host) {
      host.insertBefore(block, host.firstChild);
    }
    block.hidden = false;
    return true;
  }

  function boot() {
    if (place()) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (place() || tries > 40) clearInterval(timer);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('.station-tabs-link, [role="tab"]');
    if (!tab) return;
    if (!/sizing/i.test(tab.textContent || '') && !/sizing/i.test(tab.getAttribute('href') || '')) return;
    setTimeout(place, 50);
  });
})();
